<script setup lang="ts">
import type { Component } from 'vue';
import { computed } from 'vue';
import { cn } from '@/lib/utils';
import FeatureAvailabilityBadge from './FeatureAvailabilityBadge.vue';

const props = withDefaults(
    defineProps<{
        icon: Component;
        title: string;
        description: string;
        availability?: 'available' | 'planned' | 'coming-soon';
        tone?: 'primary' | 'secondary';
        class?: string;
    }>(),
    {
        availability: 'available',
        tone: 'primary',
        class: '',
    },
);

const iconClass = computed(() =>
    props.tone === 'secondary'
        ? 'bg-secondary/10 text-secondary'
        : 'bg-primary/10 text-primary',
);
</script>

<template>
    <div
        :class="
            cn(
                'bg-card border-border flex h-full flex-col gap-3 rounded-xl border p-6',
                props.class,
            )
        "
    >
        <span
            :class="
                cn(
                    'inline-flex size-10 items-center justify-center rounded-lg',
                    iconClass,
                )
            "
        >
            <component :is="props.icon" class="size-5" aria-hidden="true" />
        </span>
        <div class="flex flex-wrap items-center gap-2">
            <h3 class="text-lg">{{ props.title }}</h3>
            <FeatureAvailabilityBadge
                v-if="props.availability !== 'available'"
                :status="props.availability"
            />
        </div>
        <p class="text-muted-foreground text-sm leading-relaxed">
            {{ props.description }}
        </p>
    </div>
</template>
